import React, { HTMLProps } from 'react'
import styled, { css } from 'styled-components'

export const formStyles = css`
	.required-notice {
		padding: 0 ${props => props.theme.sizes.gutter.mobile.val};
	}
`

const FormView = styled.div`
	${formStyles}
`

export type FormProps = Pick<HTMLProps<HTMLFormElement>, 'onSubmit' | 'children' | 'className'> & {}
export const Form = ({ children, className, onSubmit, ...props }: FormProps) => {
	const formProps: FormProps = {
		...props,
		onSubmit: e => {
			e.preventDefault()
			onSubmit && onSubmit(e)
		},
	}
	return (
		<FormView className={`raw-form${className ? ` ${className}` : ''}`}>
			<form {...formProps}>{children}</form>
		</FormView>
	)
}
